import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Card, Button, Flex, Tag, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../hooks/useAuth";
import { fetchShiftbatsAsync } from "../features/shiftbats/shiftbatsSlice";
import Search from "antd/es/input/Search";
import { DownloadOutlined } from "@ant-design/icons";
import { doArraysOverlap } from "../util/array";
import { Link } from "react-router-dom";
import axios from "axios";
import fileDownload from "js-file-download";
import DocViewer, { DocViewerRenderers, MSDocRenderer } from "@cyntler/react-doc-viewer";
import { Helmet } from "react-helmet";

export default function ShiftbatItems() {
    // const { download } = useDownloader({ mode: "no-cors", forceDownload: true });
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [searchKey, setSearchkey] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const { auth } = useAuth();
    const dispatch = useDispatch();

    const data = useSelector((state) => state.shiftbats.shiftbats);
    const status = useSelector((state) => state.shiftbats.status);
    const error = useSelector((state) => state.shiftbats.error);

    useEffect(() => {
        if (status === "idle" || (status === "fulfilled" && data === null)) {
            dispatch(fetchShiftbatsAsync(auth.getUser().id));
        }
    }, [auth, data, dispatch, status]);

    const getAllCategories = useMemo(() => {
        if (!data || data.length === 0) return [];
        const categories = data[0].attributes?.shiftbats
            ?.map((item) => item.categories.data?.map((category) => category.attributes.name))
            .flat();
        return [...new Set(categories)];
    }, [data]);

    if (status === "pending" || data === null) return <div className="AlertInfo Loading">Loading...</div>;
    if (error) return <p>Error :(</p>;

    if (data.length === 0) return <p>No shiftbats found</p>;

    const openFile = (item) => {
        setIsModalOpen(true);
        setSelectedItem(item.file.data.attributes.url);
        // const url = item.file.data.attributes.url;
        // download file by url
        // window.open(url, "_blank");
    };

    const downloadFile = (item) => {
        const filename = new URL(item.file.data.attributes.url).pathname.split("/").pop();
        const url = item.file.data.attributes.url;
        axios
            .get(url, {
                responseType: "blob",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Methods": "GET",
                },
            })
            .then((res) => {
                fileDownload(res.data, filename);
            });
    };

    const getCategories = (item) => {
        return item.categories.data?.map((category) => category.attributes.name).join(", ");
    };

    const getShiftbats = () => {
        if (searchKey === "" && selectedCategories.length === 0) return data[0].attributes?.shiftbats;
        return data[0].attributes?.shiftbats.filter((item) => {
            const itemCategory = getCategories(item).toLowerCase();
            return (
                (searchKey.length > 0 &&
                    (item.name.toLowerCase().includes(searchKey.toLowerCase()) || itemCategory.includes(searchKey.toLowerCase()))) ||
                doArraysOverlap(selectedCategories, itemCategory.split(", "))
            );
        });
    };

    return (
        <div>
            <Search
                size="large"
                placeholder="Search shiftbats"
                allowClear
                onChange={(event) => setSearchkey(event.target.value)}
                enterButton
                value={searchKey}
            />
            <Flex wrap="wrap" style={{ marginTop: "30px" }} className="FilterTags">
                {getAllCategories?.map((category) => (
                    <Tag
                        color="default"
                        key={category}
                        className={selectedCategories.includes(category.toLowerCase()) ? "Active" : null}
                        onClick={() => {
                            if (selectedCategories.includes(category.toLowerCase())) {
                                setSelectedCategories(selectedCategories.filter((item) => item !== category.toLowerCase()));
                            } else {
                                setSelectedCategories([...selectedCategories, category.toLowerCase()]);
                            }
                        }}
                    >
                        {category}
                    </Tag>
                ))}
            </Flex>

            <Row gutter={[20, 20]} style={{ marginTop: "50px" }}>
                {getShiftbats()?.map((item) => (
                    <Col span={24}>
                        <div className="CardDocumentsWrap">
                            <Card onClick={() => openFile(item)} className="CardItem CardDocuments">
                                <h3>
                                    {item.name}{" "}
                                    {item.categories.data?.length > 0 && (
                                        <>
                                            - <Tag className="SingleTag">{getCategories(item)}</Tag>
                                        </>
                                    )}
                                </h3>
                            </Card>
                            <Button onClick={() => downloadFile(item)} shape="round" icon={<DownloadOutlined />}>
                                Download
                            </Button>
                        </div>
                    </Col>
                ))}
                {/* <div id="shiftbats"></div> */}
                {/* <div id="busable_shiftbats"></div> */}
                {/* <div id="busable_trip_planner"></div> */}
                <Helmet>
                   {/* <script src="https://enable.busable.app/busable.embed.js?operator_id=demo&views=shiftbats"></script> */}
                   {/* <script src="http://localhost:8080/busable.embed.js?operator_id=demo&views=shiftbats&local=true"></script> */}
                   {/* <script src="http://localhost:8080/busable.embed.js?operator_id=demo&views=trip_planner&local=true"></script> */}
                </Helmet>
                <Modal
                    title="Basic Modal"
                    onOk={() => {
                        setIsModalOpen(false);
                    }}
                    onCancel={() => {
                        setIsModalOpen(false);
                    }}
                    open={isModalOpen}
                >
                    {selectedItem && (
                        <DocViewer
                            style={{ height: "800px" }}
                            prefetchMethod="GET"
                            config={{
                                header: {
                                    disableFileName: true,
                                },
                            }}
                            documents={[
                                {
                                    uri: selectedItem,
                                    // fileType: getFileType(lesson?.file.data.attributes.name),
                                },
                            ]}
                            pluginRenderers={DocViewerRenderers}
                        />
                    )}
                </Modal>
            </Row>
        </div>
    );
}
